import { render, staticRenderFns } from "./V2ProfileTeammates.vue?vue&type=template&id=5fcd597a&scoped=true&"
import script from "./V2ProfileTeammates.vue?vue&type=script&lang=js&"
export * from "./V2ProfileTeammates.vue?vue&type=script&lang=js&"
import style0 from "./V2ProfileTeammates.vue?vue&type=style&index=0&id=5fcd597a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcd597a",
  null
  
)

export default component.exports